
const TractsOverviewCard = ({
    allTracts,
}) => {
    
    const tractsOverview = (tracts, type, c) => {
        let count = 0
        let countStatus = 0
        
        tracts?.forEach(tract => {
            countStatus++
            
            if (tract.status === type) {
                count++
            }
        })
        
        let persent = (count * 100) / countStatus
        
        if (c === 1) return count
        else return `${Math.floor(persent)}%`
    }
    
    return (
        
        <div className="TractsOverviewCard card table-responsive">
            <div className="px-0 py-0 card-body">
                <table className="table table-sm card-table table-borderless">
                    <tbody>
                        <tr>
                            <td>
                                <a href="#!" className="text-muted sort" data-sort="tracts-overview">
                                    Tracts Overview
                                </a>
                            </td>
                            <td>
                                <a href="#!" className="text-muted sort" data-sort="percent-of-project">
                                    % of Project
                                </a>
                            </td>
                            <td>
                                <a href="#!" className="text-muted sort" data-sort="total">
                                    Total
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>Unassigned</td>
                            <td>{tractsOverview(allTracts, 'unassigned', 0)}</td>
                            <td>{tractsOverview(allTracts, 'unassigned', 1)}</td>
                        </tr>
                        <tr>
                            <td>Assigned</td>
                            <td>{tractsOverview(allTracts, 'assigned', 0)}</td>
                            <td>{tractsOverview(allTracts, 'assigned', 1)}</td>
                        </tr>
                        <tr>
                            <td>In Progress</td>
                            <td>{tractsOverview(allTracts, 'in_progress', 0)}</td>
                            <td>{tractsOverview(allTracts, 'in_progress', 1)}</td>
                        </tr>
                        <tr>
                            <td>Completed</td>
                            <td>{tractsOverview(allTracts, 'completed', 0)}</td>
                            <td>{tractsOverview(allTracts, 'completed', 1)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
    )
    
}

export default TractsOverviewCard
